import UserChangePasswordForm from './UserChangePasswordForm';

export default UserChangePasswordForm;
